import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import findResult, {
  assignIfExists,
  findItemByMemberID,
  isValidFilter,
  removeItemByMemberID,
  selectableResult,
} from '@/utils/resultsHelper';
import actions, { collectionPermissionGroups } from '../constants';
import {
  findAllCollectionsWithCode,
  findCollection,
} from '../../state/state';
import sharingCollection, {
  collectionMembers,
  collectionPermsFromArray,
  newCollectionMember,
} from './state';

const addCollectionMembers = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const perms = collectionPermsFromArray(collectionPermissionGroups[draft.sharingCollection.permissionGroup]);
  const membersToAdd = draft.sharingCollection.membersToAdd.map((member) => newCollectionMember(member, perms));
  draft.sharingCollection.membersToAdd = [];
  item.members.results = item.members.results.concat(membersToAdd);
  item.unassignedMembers.filter = '';
});

const fetchCollectionMembers = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const members = action.assignable ? item.unassignedMembers : item.members;
  members.filter = action.filter;
  members.results = [];
  members.readStatus = isValidFilter(action.filter, members) ? states.PENDING : states.NONE;
  members.readErrors = [];
});

const hideShareCollection = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  draft.sharingCollection = sharingCollection();
  item.members = collectionMembers(10000);
  item.unassignedMembers = collectionMembers(20, 3, true);
});

const removeCollectionMember = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  item.members.results = removeItemByMemberID(item.members.results, action.memberID);
});

const shareCollection = withDraft((draft) => {
  draft.sharingCollection.saveStatus = states.PENDING;
});

const shareCollectionErrorOrSuccess = withDraft((draft) => {
  draft.sharingCollection = sharingCollection();
});

const showCollectionMembers = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const members = action.assignable ? item.unassignedMembers : item.members;
  const results = action.results.map(selectableResult);
  members.readStatus = states.SUCCESS;
  members.readErrors = [];
  members.results = results;
  members.original = results;
  members.count = action.resultsCount;
});

const showCollectionMembersError = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const members = action.assignable ? item.unassignedMembers : item.members;
  members.readStatus = states.ERROR;
  members.readErrors = [responseError(action)];
});

const showShareCollection = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  draft.sharingCollection.open = true;
  draft.sharingCollection.category = action.category;
  draft.sharingCollection.code = action.code;
  item.members = collectionMembers(10000);
  item.unassignedMembers = collectionMembers(20, 3, true);
});

const updateCollectionMemberPermissions = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const member = findItemByMemberID(item.members.results, action.memberID);
  member.permissions = collectionPermsFromArray(collectionPermissionGroups[action.permissions]);
});

const updateShareCollectionProperties = withDraft((draft, action) => {
  assignIfExists(draft.sharingCollection, action.properties);
});

const updateCurrentCollectionPermissions = withDraft((draft, action) => {
  findAllCollectionsWithCode(draft, action).forEach((category) => {
    const item = findResult(draft.collections, category, action.code);
    item.permissions = action.permissions;
  });
});

const updateCollectionMembersProperties = withDraft((draft, action) => {
  const item = findCollection(draft, action);
  const members = action.assignable ? item.unassignedMembers : item.members;
  assignIfExists(members, action.properties);
});

export default {
  [actions.ADD_COLLECTION_MEMBERS]: addCollectionMembers,
  [actions.FETCH_COLLECTION_MEMBERS]: fetchCollectionMembers,
  [actions.HIDE_SHARE_COLLECTION]: hideShareCollection,
  [actions.REMOVE_COLLECTION_MEMBER]: removeCollectionMember,
  [actions.SHARE_COLLECTION]: shareCollection,
  [actions.SHARE_COLLECTION_ERROR]: shareCollectionErrorOrSuccess,
  [actions.SHARE_COLLECTION_SUCCESS]: shareCollectionErrorOrSuccess,
  [actions.SHOW_COLLECTION_MEMBERS]: showCollectionMembers,
  [actions.SHOW_COLLECTION_MEMBERS_ERROR]: showCollectionMembersError,
  [actions.SHOW_SHARE_COLLECTION]: showShareCollection,
  [actions.UPDATE_COLLECTION_MEMBER_PERMISSIONS]: updateCollectionMemberPermissions,
  [actions.UPDATE_SHARE_COLLECTION_PROPERTIES]: updateShareCollectionProperties,
  [actions.UPDATE_CURRENT_COLLECTION_PERMISSIONS]: updateCurrentCollectionPermissions,
  [actions.UPDATE_COLLECTION_MEMBERS_PROPERTIES]: updateCollectionMembersProperties,
};
